import PropTypes from "prop-types";
import noop from "lodash/noop";
import {
  canInviteMembers,
  isSortingEnabled,
} from "@circle-react/helpers/spaceHelpers";
import { Dropdown } from "@circle-react-uikit/Dropdown";
import { InviteMemberSpaceOptions } from "./InviteMemberSpaceOptions";
import { LeaveAndDeleteSpaceOptions } from "./LeaveAndDeleteSpaceOptions";
import { ManageSpaceOptions } from "./ManageSpaceOptions";
import { MembersSortOptions } from "./MembersSortOptions";

export const MembersSpaceOptions = ({
  space,
  isAdmin,
  canMemberManageSpace,
  isMember,
  onInviteMember = noop,
}) => (
  <>
    {isMember && isSortingEnabled(space) && (
      <div className="md:hidden">
        <MembersSortOptions space={space} />
        <Dropdown.Separator />
      </div>
    )}
    {canMemberManageSpace && (
      <ManageSpaceOptions space={space} onInviteMember={onInviteMember} />
    )}
    {!isAdmin && isMember && canInviteMembers(space) && (
      <InviteMemberSpaceOptions space={space} onInviteMember={onInviteMember} />
    )}
    <LeaveAndDeleteSpaceOptions space={space} isAdmin={isAdmin} />
  </>
);

MembersSpaceOptions.propTypes = {
  space: PropTypes.object.isRequired,
  isAdmin: PropTypes.bool,
  canMemberManageSpace: PropTypes.bool,
  isMember: PropTypes.bool,
  onInviteMember: PropTypes.func,
};
